<template>
  <top-view>
    <v-card id="cardView">
      <v-row>
        <p
          v-if="userInfomation.userID == userInfo.userID"
          class="profileHeader"
        >{{ $t("profile_my_profile") }}</p>
        <p v-else class="profileHeader">{{ $t("profile") }}</p>
        <v-divider class="divider"></v-divider>
      </v-row>
      <v-layout row>
        <v-flex md1 class="hidden-sm-and-down"></v-flex>
        <v-flex xs12 md3>
          <v-row>
            <div class="text-center avatarPos">
              <v-col>
                <v-avatar width="130px" height="130px">
                  <v-img v-bind:src="userImage" />
                </v-avatar>
                <p class="nameText">{{ userInfomation.name }}</p>
                <p class="email">{{ userInfomation.emailAddress }}</p>
              </v-col>
            </div>
          </v-row>
        </v-flex>
        <v-flex xs12 md6>
          <div class="text-center contentMargin">
            <v-row>
              <v-divider class="hidden-sm-and-down avatarDivider" vertical></v-divider>
              <v-col v-show="$vuetify.breakpoint.sm" cols="1.5"></v-col>
              <v-col sm3 md4>
                <p class="headerText header">{{ $t("profile_Department") }}</p>
                <p class="content">{{ userInfomation.department }}</p>
                <p class="headerText headerBelow">{{ $t("profile_gender") }}</p>
                <p v-if="userInfomation.gender == 0" class="content">Male</p>
                <p v-else class="content">Female</p>
              </v-col>
              <v-col sm3 md4>
                <p class="headerText header">{{ $t("profile_Section") }}</p>
                <p class="content">{{ userInfomation.section }}</p>
                <p class="headerText headerBelow">{{ $t("profile_telephone") }}</p>
                <p class="content">{{ userInfomation.personalTelephoneNumber }}</p>
              </v-col>
              <v-col xs12 sm3 md4>
                <p class="headerText header">{{ $t("profile_birthday") }}</p>
                <p class="content">{{ formatDate(userInfomation.birthDate) }}</p>
                <p class="headerText headerBelow">{{ $t("profile_address") }}</p>
                <p class="content">{{ userInfomation.homeAddress }}</p>
              </v-col>
              <v-col v-show="$vuetify.breakpoint.sm" cols="1.5"></v-col>
            </v-row>
          </div>
        </v-flex>
        <v-flex md2 class="hidden-sm-and-down"></v-flex>
      </v-layout>
      <div v-if="userInfomation.userID != userInfo.userID" class="text-center">
        <v-btn class="btnMargin" id="btnBack" v-on:click="cancelClicked">{{ $t("web_back") }}</v-btn>
      </div>
      <div v-else class="text-center">
        <v-btn class="btnMargin mx-2" id="btnCancel" v-on:click="cancelClicked">{{ $t("web_back") }}</v-btn>
        <v-btn
          class="btnMargin mx-2"
          id="btnEdit"
          v-on:click="editProfile"
        >{{ $t("common_update") }}</v-btn>
      </div>
    </v-card>
  </top-view>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import TopView from "../../components/commonui/topView/TopViewFullScreen";
import { DefaultValues } from "@/utilities/CommonUtilities";
import moment from "moment";

export default {
  components: { TopView },
  data() {
    return {
      userInfomation: {}
    };
  },
  computed: {
    ...mapGetters(["getUserByID"]),
    ...mapState(["userInfo"]),
    userImage() {
      if (this.userInfomation && this.userInfomation.profiolePhoto != null) {
        return `data:image/png;base64,${this.userInfomation.profiolePhoto}`;
      } else {
        return DefaultValues.no_image;
      }
    }
  },
  created() {
    let userID = this.$route.params.userid;
    this.userInfomation = this.getUserByID(userID);
    this.userName = this.userInfomation.userName;
  },
  methods: {
    cancelClicked() {
      this.$router.push({ name: "home" });
    },
    editProfile() {
      this.$router.push("/editprofile/" + this.userInfo.userID);
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY/MM/DD");
      }
    }
  },
  inject: ["notifyBus"]
};
</script>

<style scoped>
#cardView {
  width: 100%;
  height: 100%;
}
.profileHeader {
  margin-top: 37px;
  margin-left: 60px;
  width: 142px;
  height: 33px;
  margin-right: 20px;
  text-transform: uppercase;
  color: #333333;
  font: normal normal bold 24px/33px Open Sans;
  white-space: nowrap;
}
.avatarPos {
  width: 100%;
  margin-top: 88px;
}
.divider {
  margin-top: 63px;
  margin-right: 10px;
}
.avatarDivider {
  margin-top: 88px;
}
.nameText {
  margin-top: 16px;
  width: 100%;
  height: 22px;
  text-align: center;
  font: normal normal bold 16px/22px Open Sans;
  color: #333333;
  opacity: 1;
}

.header {
  margin-top: 106px;
}

@media only screen and (max-width: 960px) {
  .header {
    margin-top: 10px;
  }
}

@media only screen and (max-width: 600px) {
  .contentMargin {
    margin-left: 20px;
    margin-right: 20px;
  }
}

.headerBelow {
  margin-top: 61px;
}

.headerText {
  text-align: center;
  width: 100%;
  height: 22px;
  font: normal normal bold 16px/26px Open Sans;
  color: #333333;
}

.content {
  text-align: center;
  width: 100%;
  height: 22px;
  font: normal normal normal 16px/26px Open Sans;
  color: #333333;
}
#btnBack {
  background-color: #e561a9;
  width: 296px;
  height: 35px;
  color: #ffffff;
  font: normal normal bold 14px/8px Open Sans;
  text-align: center;
  text-transform: uppercase;
  opacity: 1;
  border-radius: 1px;
}

#btnCancel {
  background-color: #e561a9;
  width: 128px;
  height: 35px;
  color: #ffffff;
  font: normal normal bold 14px/8px Open Sans;
  text-align: center;
  text-transform: uppercase;
  opacity: 1;
  border-radius: 1px;
}

#btnEdit {
  background-color: #5e81ed;
  width: 128px;
  height: 35px;
  color: #ffffff;
  font: normal normal bold 14px/8px Open Sans;
  text-align: center;
  text-transform: uppercase;
  opacity: 1;
  border-radius: 1px;
}

.btnMargin {
  margin-top: 180px;
  margin-bottom: 170px;
}

@media only screen and (max-width: 600px) {
  .btnMargin {
    margin-top: 50px;
    margin-bottom: 50px;
  }
}

.email {
  margin-top: 10px;
  width: 100%;
  height: 16px;
  font: normal normal normal 14px/16px Helvetica Neue;
  color: #c4c4c4;
  opacity: 1;
  text-align: center;
}
</style>